import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  fontAwesomeDropdown: {
    width: "calc(100% - 32px)",
    height: 64,
    marginLeft: 32,
    marginBottom: theme.hv.spacing.xs,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    float: "left",
    marginLeft: -8,
  },
  textContainer: {
    lineHeight: "32px",
  },
  noIconTextContainer: {
    paddingLeft: 24,

    "$placeholder &": {
      paddingLeft: 0,
    },
  },
  placeholder: {},
}));

export default styles;
